import { FC } from 'react'
import ReactModal from 'react-modal'
import { CommentModalProps, Review } from 'backoffice/components/DropRequests/types/types'
import Pill from 'backoffice/components/DropRequests/Pill'
import ReviewInfo from 'backoffice/components/DropRequests/ReviewInfo'

//Assets
import { ReactComponent as IconClose } from 'images/icons/close.svg'

import styles from './CommentModal.module.scss'

interface CommentModalInternalProps {
  close: () => void
  name: string
  review: Review | Partial<Review>
}

const CommentModalContent: FC<CommentModalInternalProps> = ({ close, name, review }) => {
  const { status, comment, amount, reviewer, created_at } = review

  const iconSize = 24
  return (
    <div className={styles.comment}>
      <IconClose width={iconSize} className={styles.iconClose} height={iconSize} onClick={close} />
      <div className={styles.sectionName}>Comment</div>
      <div className={styles.title}>{name}</div>
      <div className={styles.status}>
        <Pill status={status} approvedAmount={amount} />
      </div>
      <div className={styles.info}>
        <ReviewInfo reviewerEmail={reviewer} reviewedDate={created_at} />
      </div>
      <div className={styles.description}>
        <div className={styles.descriptionContent}>{comment}</div>
      </div>
    </div>
  )
}

const CommentModal: FC<CommentModalProps> = ({ review, onCloseClick, isOpen, name }) => {
  return (
    <>
      <ReactModal
        className={styles.commentModal}
        isOpen={isOpen}
        onRequestClose={onCloseClick}
        shouldFocusAfterRender
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
      >
        <CommentModalContent review={review} close={onCloseClick} name={name} />
      </ReactModal>
    </>
  )
}

export default CommentModal
